import { useEffect } from '../../../src/InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss} from '../../../src/CommonImports';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import './../css/GLayOutSpacing.css';
import './../css/GAnimetion.css';
import './../css/GAboutUs.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function GJobAnimetedAboutUs() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
        <section className="section-box bg-banner-about">
            <div className="banner-hero banner-about pt-20">
                <div className="banner-inner">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="block-banner">
                                <h1 className="heading-banner heading-lg">The #1 Job Board for Graphic Design Jobs</h1>
                                <div className="banner-description box-mw-70 mt-30">Search and connect with the right candidates faster. This talent seach gives you the opportunity to find candidates who may be a perfect fit for your role</div>
                                <div className="mt-60">
                                    <div className="box-button-shadow mr-10">
                                        <a href="#" className="btn btn-default">Contact us</a>
                                    </div>
                                    <a href="#" className="btn">Support center</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 d-none d-lg-block">
                            <div className="banner-imgs">
                                <img alt="jobhub" src={mediaUrl+"banner-img.png?"+sasToken} className="img-responsive main-banner shape-3"/>
                                <span className="banner-sm-1"><img alt="jobhub" src={mediaUrl+"banner-sm-1.png?"+sasToken} className="img-responsive shape-1"/></span>
                                <span className="banner-sm-2"><img alt="jobhub" src={mediaUrl+"banner-sm-2.png?"+sasToken} className="img-responsive shape-1"/></span>
                                <span className="banner-sm-3"><img alt="jobhub" src={mediaUrl+"banner-sm-3.png?"+sasToken} className="img-responsive shape-2"/></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
    );
}
export default GJobAnimetedAboutUs;